// extracted by mini-css-extract-plugin
module.exports = {"app":"styles_app__1aTJl","loader":"styles_loader__2Dyyj","appLoaderWrapper":"styles_appLoaderWrapper__1CMXa"};